<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="steps">
          <el-col :span="24">
            <el-steps :active="active" align-center simple finish-status="success">
              <el-step v-for="item in steps" :key="item.title" :title="item.title" :description="item.description" />
            </el-steps>
          </el-col>
        </el-row>
        <div class="steps-content" v-if="active == 0">
          <el-row>
            <el-col>
              <el-form ref="companyForm" :model="formData" :rules="rules" label-width="180px">
                <!-- <el-form-item label="选择任务（已审核）" prop="name" id="list">
                  <el-select v-model="formData.name" placeholder="请选择对账清单">
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-button style="margin-left:10px" type="text" @click="mxRedirect('/bill/create')">
                    如果没有对账清单，请先上传
                  </el-button>
                </el-form-item> -->
                <el-form-item label="备注" prop="desc" id="desc">
                  <el-input class="remarks" type="textarea" v-model="formData.desc" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                </el-form-item>
                <el-form-item>
                  <!-- <el-button type="primary" size="medium" @click="openDialog">弹窗</el-button> -->
                  <el-button type="primary" size="medium" @click="formNext('companyForm')">下一步</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="steps-content" v-if="active == 1">
          <el-alert type="warning" :closable="false" id="el-alert">
            <template slot="title">
              <div>提示：</div>
              <div>1、导入数据需要跟模板格式一样方可导入</div>
              <div>2、单个批次模板数据不能超过{{max_settlement_num}}条</div>
              <div>3、如果有未签约的数据，请先人才签约后再上传。</div>
            </template>
          </el-alert>
          <upload-excel
            @remove_file="handleRemoveFile"
            @return_url="handUploadFile"
            @handleSuccess="handleSuccess"
            :loadingStaus="loadingStaus"
            :dir="'task'"
            selectfiles="importExcel"
            postfiles="submitImportExcel"
            ossfile="ossExcelFile"
            ref="uploadImg"
            :tableColumns="columns"
            :title="title"
            :tableKeyMap="keyMap"
            :tableData="tableData"
            :max_width="1000"
            :max_height="1000">

            <template #table_top>
              <div class="all-num-tips">
                <div>
                  <div class="name">总结算金额合计</div>
                  <div class="value">{{statistics.all_money || 0}}</div>
                </div>
                <div>
                  <div class="name">总预抵扣税费合计</div>
                  <div class="value">{{ statistics.all_tax || 0 }}</div>
                </div>
              </div>
            </template>
          </upload-excel>
        </div>
        <div class="btn-wrapper">
          <el-button v-if="active < steps.length - 1"  v-show="active == 2" size="medium" type="primary" @click="next">

          </el-button>
        </div>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
         <el-form ref="moneyForm" :model="formMoneyData" :rules="moneyRules" label-width="100px">
            <el-col :span="24" class="content-left">
              <el-form-item label="结算笔数" prop="num">
                <el-input-number v-model="formMoneyData.num" :precision="0" :step="1" :max="max_settlement_num"></el-input-number>
              </el-form-item>
              <el-form-item label="结算金额" prop="money">
                <el-input v-model="formMoneyData.money">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
      </template>
    </ModalDialog>
    <NoticeDialog :dialogVisible="dialogVisible" :htmlData="htmlData" @know="know" @handleClose="handleClose"/>
  </div>
</template>
<script>
import UploadExcel from "@/components/UploadExcel";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import NoticeDialog from '@/components/NoticeDialog'
import { huifuList } from "@/utils/ylBankList";  

export default {
  components: {
    UploadExcel,
    PageHeaderLayout,
    ModalDialog,
    NoticeDialog
  },
  data() {
    // 笔数验证
    var validateNum = (rule, value, callback) => {
      console.log(this.tableData.length)
      if (this.tableData.length <= 0) {
          callback(new Error('笔数不为空'))
      } else if (this.tableData.length !== value) {
        callback(new Error('笔数不匹配'))
      } else {
        callback()
      }
    }

    // 总金额验证
    var validateMoney = (rule, value, callback) => {
      var _this = this
      let totalMoney = this.tableData.reduce(function (total, currentValue) {
        return _this.$utils.sumTotal(total, currentValue.money)
      }, 0)
      totalMoney = Math.round(totalMoney * 100) / 100
      console.log(totalMoney, "totalMoney")
      console.log(value, "value")
      if (this.tableData.length <= 0) {
        callback(new Error('笔数不为空'))
      } else if (totalMoney != value) {
        callback(new Error('总金额不匹配'))
      } else {
        callback()
      }
    }
    return {
      statistics:{
        all_money:0,
        all_tax:0
      },
      isHuifu: false,
      isLaowuCompany:false,
      nowCompany:localStorage.getItem('nowCompany')?JSON.parse(localStorage.getItem('nowCompany')):{},
      max_settlement_num:1000,
      dialogVisible: false,
      htmlData: '',
      id: '',
      pages: [],
      localStroageId: '',
      loadingStaus: false,
      active: 1,
      dialogData:{
        visible: false,
        title: '',
        width: '28%',
        loading: true,
        modal: true
      },
      title: {
        selectBtn: "选择本地Excel文件",
        uploadBtn: "确定无误后，上传结算数据",
        downloadBtn:"下载金额核对表",
        customBtn:'未签约任务结算清单',
        deliveryBtn:"未交付任务结算清单",
        downCardUnAuthBtn: '',
      },
      steps: [
        // {
        //   title: '填写基本信息',
        //   description: '',
        //   content: 'step1',
        // },
        {
          title: '任务结算导入',
          description: '',
          content: 'step2',
        },
        {
          title: '金额验证&提交结算单',
          description: '',
          content: 'step3',
        },
      ],
      tableData: [],
      tableHeader: [],
      tableDataArr: [],
      categoryList: [],
      filename: '',
      url: '',
      isSign: '',
      columns: [
        {
          title: "姓名",
          value: "bank_account_name"
        },
        {
          title: "身份证号码",
          value: "id_number",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "账号",
          value: "bank_account_no",
        },
        {
          title: "结算金额",
          value: "money"
        },
        {
          title: "个税",
          value: "after_tax"
        },
		{
		title: "预扣增值税和附加税",
		value: "added_tax_money",
		header_align: "center",
		align: "center",
		width: 180,
		},
        {
          title: "是否签约",
          value: "is_sign"
        },
        {
          title: "是否交付",
          value: "is_delivery"
        },
        {
          title: "银行名称",
          value: "bank_name",
        },
        {
          title: "开户行名称",
          value: "bank_branch",
        },
        {
          title: "备注",
          value: "remark",
        },
        {
          title: "编码",
          value: "code"
        },
        {
          title: "下发类型",
          value: "send_type",
        },
      ],
      keyMap: {
        'code': "code",
        'name': "bank_account_name",
        'bankCard': "bank_account_no",
        'accountName': "bank_branch",
        'moneyType':'money_type_name',
        'money': "money",
        'phone': "mobile",
        'idCard': "id_number",
        'cardType': "id_type",
        'remark': "remark",
        'type': "send_type",
        'bankName': "bank_name",
        'green_trade_no': "green_trade_no"
      },
      // formData:{
      //   file_url: '',
      //   status: 0
      // },
      formData: {
        name: '',
        desc: ''
      },
      formMoneyData: {
        num: '',
        money: '',
      },
      moneyRules: {
        num: [
          { required: true, message: '笔数不能为空', trigger: 'blur' },
          { validator: validateNum, trigger: 'blur' },
        ],
        money: [
          { required: true, message: '总金额不能为空', trigger: 'blur'},
          { validator: validateMoney, trigger: 'blur' },
        ]
      },
      rules: {
        // name: [
        //   { required: true, message: '结算清单名不能为空', trigger: 'blur' }
        // ],
        desc: [
          { required: true, message: '备注不能为空', trigger: 'blur'}
        ]
      }
    };
  },
  watch: {
    isSign(val) {
      return val
    },
    id(val) {
      if(this.pages.includes('task')) {
        if(val != this.localStroageId) {
          setTimeout(() => {
            this.dialogVisible = true
          }, 500)
        }else {
          this.dialogVisible = false
        }
      }else {
        this.dialogVisible = false
      }
    },
  },
  mounted() {
    this.init()
    this.getId()
    let bankTypeList = ['sycard', 'syalipay', 'sywechat','lingxin','lingxincard','lingxinalipay','lingxinwechat']
    this.updateSettlementFun(bankTypeList,100)
    this.getIsLaoWu()
    this.getIsHuifu()
  },
  methods: {
    // 是否是劳务公司
    async getIsLaoWu(){
      let settlementList = await this.$api.getUserSettlement({
        company_id:JSON.parse(localStorage.getItem('nowCompany')).id
      })
      // console.log(settlementList)
      let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
      let newSettlementList = Object.assign(settlementList, [])
      
      newSettlementList.map(item=>{
        if(item.id == companyIds){
          if(item.is_labor_dispatch != 0){
            this.isLaowuCompany = true
          }
        }
      })

      if(!this.isLaowuCompany){
          this.columns.map((item,index)=>{
            if(item.value == 'labor_dispatch_money'){
              this.columns.splice(index,1)
            }
          })
          this.title.downloadBtn = ""//隐藏下载按钮
      }else{
        this.columns.map((item)=>{
            if(item.value == 'money'){
              item.title = '结算金额'
            }
        })
      }
	
	if(this.isLaowuCompany){
		this.columns = [
		{
		title: "姓名",
		value: "bank_account_name"
		},
		{
		title: "身份证号码",
		value: "id_number",
		},
		{
		title: "手机号码",
		value: "mobile",
		},
		{
		title: "账号",
		value: "bank_account_no",
		},
		{
		title: "结算金额",
		value: "money"
		},
		{
		title:'增值税',
		value:'value_added_tax'
		},
		{
		title:'附加税',
		value:'additional_tax'
		},
		{
		title:'个税',
		value:'personal_income_tax'
		},
		{
		title: "是否签约",
		value: "is_sign"
		},
		{
		title: "银行名称",
		value: "bank_name",
		},
		{
		title: "开户行名称",
		value: "bank_branch",
		},
		{
		title: "备注",
		value: "remark",
		},
		{
		title: "编码",
		value: "code"
		},
		{
		title: "下发类型",
		value: "send_type",
		}
		]
	}
    },
    getIsHuifu(){
      let trade_bank_type = this.nowCompany.trade_bank_type;
      this.isHuifu = huifuList.includes(trade_bank_type);
      if(this.isHuifu){
        this.title.downCardUnAuthBtn = '银行卡未认证人员清单'
        let index = this.columns.findIndex(item=>item.value === "is_sign")
        this.columns.splice(index,0,{
          title:'银行卡认证',
          value:'card_is_auth'
        })
      }
    },
    updateSettlementFun(bankTypeList,max_settlement_num){
        bankTypeList = bankTypeList || []
        if(bankTypeList.includes(this.nowCompany.trade_bank_type)){
            this.max_settlement_num = max_settlement_num || this.max_settlement_num
        }
    },
    know(value) {
      if(value) {
        this.$storage.set("accountment_id", this.id)
      }
      this.dialogVisible = false
    },
    handleClose(value) {
      if(value) {
        this.$storage.set("accountment_id", this.id)
      }
      this.dialogVisible = false
    },
    async getId() {
      let data = await this.$api.getPrice()

      this.id = data?.announcement?.id
      this.htmlData= data.announcement?.content
      this.pages =  data.announcement?.pages || []
      if(this.pages.includes('task')) {
        this.localStroageId = this.$storage.get("accountment_id")
        if(this.localStroageId) {
          this.dialogVisible = false
        } else {
          setTimeout(() => {
            this.dialogVisible = true
          }, 500)
        }
      }else {
        this.dialogVisible = false
      }
    },

    // 保存处理
    async formSubmit() {
      this.dialogData.loading = true
      console.log("formData -> ", this.tableData);
      this.tableData.forEach((item) => {
        for(var i in item) {
          if(i == 'undefined' || i=='is_delivery') {
            delete item[i];
          }
        }
      })
      try {
        const res = await this.$api.saveTask({
          verify:{
            num:this.formMoneyData.num,
            money:this.formMoneyData.money
          },
          batch: {
            name: this.filename,
            file_url: this.url,
            desc: this.formData.desc
          },
          detail: this.tableData
        })
        if (res) {
          this.$message({
            message: '批次数据保存成功',
            type: 'success'
          })
          this.active++
        }
        this.init()
        this.dialogData.loading = false
        this.goBack()
      } catch(err) {
        console.log('err is ->', err)
        this.dialogData.loading = false
      }
    },
    openDialog() {
      this.dialogData.visible = true
      this.dialogData.title = '验证金额'
      this.initForm()
    },
    // 初始化form，将添加，编辑共同数据抽取出来
    async initForm() {
      this.dialogData.loading = false
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.isInherit= true
        this.namePrefix= ''
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initData()
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['moneyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    async init() {
      // this.categoryList = await this.$api.getBillCategoryList()
    },
    //返回上一页
    goBack() {
      this.$router.push({ path: "/task" });
    },
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    async handUploadFile({ url, filename }) {
       let flag = false
       let existNaN = false
       this.tableData.map(item=>{
         existNaN = isNaN(item.money)
         if(Number(item.money)<0||Number(item.money)==0){
           flag = true
         }
       })
       if(existNaN){
           this.$message.error('下发金额存在非数字')
           return false
       }
       
       if(flag){
          this.$message.error('下发金额必须大于0')
          return false
       }
       
      console.log(url, filename)
      if (url && filename) {
        this.url = url
        this.filename = filename
      }
      this.openDialog()
    },
	// 通过身份证获取签约情况
	async getIsSign(idcard) {
      let status = await this.$api.getTaskSigns({
        idcards: idcard,
      });
      let obj = {};
      obj = status;
      return obj;
	},
  // 通过身份证获取签约情况
	async getCardIsAuth(cards) {
      let status = await this.$api.getCardIsAuth({
        card_nos: cards,
      });
      let obj = {};
      obj = status.succeed;
      return obj;
	},
  //Excel读取成功
  async handleSuccess({results, header}) {
    console.log(results,header);
      this.tableHeader = header;
      results.splice(0, 1)
      let arr = [];
      let cardArr = [];
      results.map((item) => {
        arr.push(item.id_number.trim());
        cardArr.push(item.bank_account_no)
      });
      let res = await this.getIsSign(arr);
      let cardAuthList = []
      if(this.isHuifu){
        cardAuthList = await this.getCardIsAuth(cardArr);
      }
      results.map(item=>{
        item.bank_account_name= item.bank_account_name?.toString()?.trim() || ''
        item.id_number = item.id_number.trim()
        item.mobile = item.mobile.toString().trim()
        item.is_sign = "未签约";
        item.is_delivery = "未交付";

        if(!this.isLaowuCompany){
          item.remark =item?.remark?.trim()|| "服务费";
        }
        let tar = res.succeed;
        if (tar.length && tar.includes(item.id_number)) {
          item.is_sign = "已签约";
        }
        if (res.deliver_succeed.length && res.deliver_succeed.includes(item.id_number)) {
          item.is_delivery = "已交付";
        }
        if(this.isHuifu){
          item.card_is_auth = "未认证"
          if (this.isHuifu && cardAuthList.length && cardAuthList.includes(item.bank_account_no)) {
            item.card_is_auth = "已认证";
          }
        }
       

        // 处理下发类型
        if(item.money_type_name == '税前'){
            item.money_type = 1
        }else if(item.money_type_name == '税后'){
            item.money_type = 2
        }
      })

      if(this.isLaowuCompany){
        // 计算劳务费
        let arr_data = []
        results.map(item=>{
          arr_data.push({
            idcard:item.id_number,
            ...item
          })
        })
        const newTableData = await this.$api.postCheckLaborFee({
          batch_data:arr_data
        })
        this.tableData = newTableData
      }else{
        let arr_data = []
        results.map(item=>{
          arr_data.push({
            idcard:item.id_number,
            ...item
          })
        })
       
        const newTaxTableData = await this.$api.getTaxbasisTask({
          batch_data:arr_data
        })
        let all_money = 0;
        let all_tax = 0;
        newTaxTableData.map(item=>{
          all_money+=parseFloat(item.money);
          all_tax = parseFloat(all_tax) + parseFloat(item.after_tax) + parseFloat(item.added_tax_money);
        })
        this.statistics = {
          all_money:all_money.toFixed(2),
          all_tax:all_tax.toFixed(2)
        }
        this.tableData = newTaxTableData
      }
      
      if(results.length>this.max_settlement_num){
          this.$message({
            message: `单次结算不能超过${this.max_settlement_num}条，请表格拆分后，重新结算`,
            type: 'warning',
            duration:5000
          })
      }
    },

    //步骤
    formNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.active++
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    next() {
      this.active++
      if(this.active == 2) {
        this.$message(
          {
            message: '恭喜你，操作完成',
            type: 'success'
          }
        )
      }
    },
    prev() {
      this.active--;
    },
  }
};
</script>
<style scoped lang="stylus">
.steps
  margin: 20px 0
.back-btn
  position: absolute
  right: 50px
  top: 150px
/deep/.el-alert__content
  margin-left: 0;
#el-alert
  margin-top: -20px
/deep/.el-alert__title
  font-size: 13px
.steps-content
  margin-top: 40px
  border-radius: 6px
  min-height: 200px
.remarks
  width: 60%
#desc
  margin-left: 4px
.btn-wrapper
  position: relative
  top: -55px
.nextBtn
  margin-left: -100px
</style>
<style scoped lang="scss">
.all-num-tips{
  width: 100%;
  display: flex;
  &>div{
    padding: 16px;
    width: 250px;
    background: #f7f8fa;
    margin-right: 20px;
    border-radius: 8px;
    .name{
      font-size: 16px;
      color: #bbb;
    }
    .value{
      font-size: 20px;
      color:#000;
      margin-top: 10px;
    }
  }
}
</style>